var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon4Breaks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75098 3.75107H29.0824C30.8398 3.75107 32.2489 5.16013 32.2489 6.9175V11.6671C32.2489 13.4087 30.8398 14.8336 29.0824 14.8336H25.916V19.5832C25.916 23.0821 23.082 25.9161 19.5831 25.9161H10.0838C6.58494 25.9161 3.75098 23.0821 3.75098 19.5832V3.75107ZM29.0824 29.0826H3.75098V32.249H29.0824V29.0826ZM22.7496 19.5832C22.7496 21.3247 21.3247 22.7496 19.5832 22.7496H10.0839C8.34234 22.7496 6.91744 21.3247 6.91744 19.5832V6.91745H22.7496V19.5832ZM25.916 11.6671H29.0825V6.91745H25.916V11.6671Z",
    fill: "#5E5F66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4Breaks);
export default __webpack_public_path__ + "static/media/Icon 4 Breaks.b4f70deb385e448ee5ef7072ece50d36.svg";
export { ForwardRef as ReactComponent };